import jwt_decode from "jwt-decode";
import produce from "immer";
import setAuthToken from "../../utils/setAuthToken";
import { ADMIN_LOGIN, ADMIN_LOGOUT, SET_COVER_IMAGE } from "../types";
const initialState = {
  admin: {
    isAuthenticated: false,
    data: {},
  },
  superuser: {
    isAuthenticated: false,
    data: {},
  },
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN:
      let decoded = jwt_decode(action.payload.token);
      console.log(decoded);
      setAuthToken(action.payload.token);
      return produce(state, (draft) => {
        draft.admin = {
          isAuthenticated: true,
          data: decoded,
        };
      });
    case SET_COVER_IMAGE:
      return produce(state, (draft) => {
        draft.admin.data.cover = action.payload;
      });
    case ADMIN_LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("primary");
      localStorage.removeItem("secondary");
      return produce(state, (draft) => {
        draft.admin = {
          isAuthenticated: false,
          data: {},
        };
      });
    default:
      return state;
  }
};

export default authReducer;
